
import Vue from 'vue'
import {
  VListGroup,
  VListItemContent,
  VListItemSubtitle,
  VListItemTitle,
} from 'vuetify/lib'
import JcdcNavRouterLinkMobile from '@/components/jcdc/JcdcNavRouterLinkMobile.vue'
import { filteredMenu, navList, userInfo } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouterMobileMenu',
  components: {
    VListGroup,
    VListItemContent,
    VListItemSubtitle,
    VListItemTitle,
    JcdcNavRouterLinkMobile,
  },
  props: {
    item: { type: Object as () => navList, required: true },
    userInfo: { type: Object as () => userInfo, required: true },
    menuLevel: { type: Number, default: 0 },
    routeTest: { type: Array as () => string[], default: (): [] => [] }, // For Testing
  },
  data() {
    return {
      drawer: false,
      navPosition: 80,
      displayChildNav: false,
      menuOpen: false,
    }
  },
  methods: {
    filteredMenu,
    showChildrenInNav(item) {
      return (
        !!item.children &&
        item.meta?.childrenInNav != false &&
        item.meta?.navGroup != true
      )
    },
    isActive(item) {
      if ('path' in item) {
        let pathArray
        if (process.env.NODE_ENV != 'storybook')
          pathArray = this.$route.path.split('/')
        else if (process.env.NODE_ENV == 'storybook' && this.routeTest)
          pathArray = this.routeTest
        return pathArray.includes(item.path)
      }
      return false
    },
  },
})
